export default "__VITE_ASSET__BzbrMsib__"